module.exports = __webpack_public_path__ + "img/Expedition1_icon.8ea398b0.png";